import {
  addLeadAddress,
  addLeadAltPhoneNumber,
  addLeadDivisionId,
  addLeadLocationTypeId,
  addLeadNote,
  addLeadPreferredMethodOfContact,
  addLeadPreferredTimeOfContact,
  entityCampaignId,
  addLeadFieldNameLabels,
  entityLeadSourceId,
  entityNextActionDate,
  entityReferral,
  entityTargetPests,
} from '@user/components/Settings/EntityFormSettings/constants'

/** Rows shown under "Required by System"; read-only, not persisted. */
export const SYSTEM_REQUIRED_FIELDS: {
  label: string
  determinedByAssignment: boolean
}[] = [
  {
    label: 'First Name, Last Name, Or Company Name',
    determinedByAssignment: false,
  },
  { label: 'Phone Number or Email Address', determinedByAssignment: false },
  { label: 'Sales Team', determinedByAssignment: true },
  { label: 'Owner', determinedByAssignment: true },
  { label: 'Sales Funnel', determinedByAssignment: true },
  { label: 'Lead Status', determinedByAssignment: true },
]

/**
 * Display labels of the built-in fields in the order the Add Field modal lists them (AC order).
 * The backend returns built-ins by label only, so this is used purely to sort the options.
 */
export const ADDITIONAL_FIELD_NAMES: string[] = [
  addLeadAddress,
  addLeadAltPhoneNumber,
  addLeadLocationTypeId,
  addLeadDivisionId,
  addLeadPreferredMethodOfContact,
  addLeadPreferredTimeOfContact,
  entityNextActionDate,
  addLeadNote,
  entityTargetPests,
  entityCampaignId,
  entityLeadSourceId,
  entityReferral,
].map((name) => addLeadFieldNameLabels[name])
